import { Routes } from '@angular/router';
import { PlanType } from '@app/reducers/account/account-subscription.model';
import { SubscriptionPlanGuard } from '@app/shared/subscription-plan/subscription-plan.guard';

import { PermissionGuard } from '../permission-guard.service';
import { defaultInsightView } from './helpers/view.helper';
import { insightsRoutesGuard } from './insights-routes.guard';

export const insightsRoutes: Routes = [
  {
    path: 'insights',
    data: {
      subscriptionPlan: PlanType.BASIC,
      permission: ['View log'],
    },
    canActivate: [SubscriptionPlanGuard, PermissionGuard],
    children: [
      {
        path: ':view',
        loadComponent: () => import('./insights-page.component').then((m) => m.InsightsPageComponent),
        canActivate: [insightsRoutesGuard],
      },
      {
        path: '',
        redirectTo: defaultInsightView,
        pathMatch: 'full',
      },
    ],
  },
];
